import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import WhatWeDoPage from "./pages/WhatWeDoPage";
import ProjectsPage from "./pages/ProjectsPage";
import ConsultPage from "./pages/ConsultPage";
import CareersPage from "./pages/CareersPage";
import AdminPanel from './admin/AdminPanel';


export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/what-we-do" element={<WhatWeDoPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/consult" element={<ConsultPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/admin" element={<AdminPanel />} />

      </Routes>
    </Router>
  );
}
